export type SensorCode =
  | "RS" // Reference Sensor == Controlled Pressure
  | "ISA" // Input Sensor A
  | "ISB" // Input Sensor B
  | "ISC" // Input Sensor C
  | "SP" // Setpoint
  | "IV" // Input Valve
  | "EV" // Exhaust Valve
  | "IEV" // Combined Input/Exhaust
  | "DT"; // Device Temperature

export const sensorCodes = Object.freeze([
  "RS",
  "ISA",
  "ISB",
  "ISC",
  "SP",
  "IV",
  "EV",
  "IEV",
  "DT",
]);

export function isSensorCode(code: string): code is SensorCode {
  return sensorCodes.includes(code);
}
